<tabs-inner-wrap>
  @if (isSelfAuthoring()) {
    <details-section class="scoring-weights-details" [showDetails]="false" [title]="'simulationBuilder.SCORING_WEIGHTS_TITLE' | transloco" [description]="'simulationBuilder.SCORING_WEIGHTS_DESCRIPTION' | transloco">
      <span headerAction #scoreLastSessionBtnWrapper>
        <button
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          [disabled]="isScoreLastSessionDisabled"
          (click)="scoreLastSession()"
        >
          {{ 'simulationBuilder.SCORE_LAST_SESSION' | transloco }}
        </button>
      </span>
      <qai-tooltip
        *ngIf="isRefinementInProgress"
        [qaiFloating]="scoreLastSessionBtnWrapper"
        [placement]="'below-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.REFINEMENT_IN_PROGRESS_TOOLTIP' | transloco }}
      </qai-tooltip>
      <qai-tooltip
        *ngIf="!isRefinementInProgress && (isV2WithNoFacts || isMissingMessagingThemes)"
        [qaiFloating]="scoreLastSessionBtnWrapper"
        [placement]="'below-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.TESTING_MESSAGING_TOOLTIP' | transloco }}
      </qai-tooltip>
      <qai-tooltip
        *ngIf="!isRefinementInProgress && !isV2WithNoFacts && !isMissingMessagingThemes && hasEmptyFacts"
        [qaiFloating]="scoreLastSessionBtnWrapper"
        [placement]="'below-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.FACTS_CANNOT_BE_EMPTY' | transloco }}
      </qai-tooltip>
      <qai-tooltip
        *ngIf="!isRefinementInProgress && !isV2WithNoFacts && !isMissingMessagingThemes && !hasEmptyFacts && isMissingSkillsRubric"
        [qaiFloating]="scoreLastSessionBtnWrapper"
        [placement]="'below-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.SKILLS_RUBRIC_REQUIRED_TOOLTIP' | transloco }}
      </qai-tooltip>
      <qai-tooltip
        *ngIf="!isRefinementInProgress && !isV2WithNoFacts && !isMissingMessagingThemes && !hasEmptyFacts && !isMissingSkillsRubric && isMissingMethodology"
        [qaiFloating]="scoreLastSessionBtnWrapper"
        [placement]="'below-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.METHODOLOGY_REQUIRED_TOOLTIP' | transloco }}
      </qai-tooltip>
      <ng-container *ngTemplateOutlet="scoringSections"></ng-container>
    </details-section>
  } @else {
    <ng-container *ngTemplateOutlet="scoringSections"></ng-container>
  }

  @if (showAccuracyFeedback) {
    <accuracy-feedback-section />
  }
</tabs-inner-wrap>

<score-last-session-modal
  [open]="showScoreLastSessionModal"
  [simulationName]="simulationName"
  [callUuid]="callUuid"
  [moduleUuid]="moduleUuid"
  [replicaId]="replicaId"
  (openChange)="showScoreLastSessionModal = $event"
  (closeModal)="showScoreLastSessionModal = false"
  (confirm)="showScoreLastSessionModal = false"
></score-last-session-modal>

<ng-template #scoringSections>
  <overall-scoring-section [isSelfAuthoring]="isSelfAuthoring()"></overall-scoring-section>
  @if (isSelfAuthoring()) {
    <app-message-block
      class="scoring-review-notice"
      contentPlacement="left"
      icon="message-text-square"
      [featuredIcon]="true"
    >
      {{ 'simulationBuilder.SCORING_AI_REVIEW_NOTICE' | transloco }}
    </app-message-block>
  }
  <methodology-section *ngIf="!methodolgyDisabled" [isSelfAuthoring]="isSelfAuthoring()"></methodology-section>
  <messaging-section *ngIf="!messagingDisabled" [isSelfAuthoringRoleplay]="isSelfAuthoring()"></messaging-section>
  <skill-section *ngIf="!skillsDisabled" [isSelfAuthoring]="isSelfAuthoring()"></skill-section>
</ng-template>
